import {useMemo} from 'react'
import {useTable, ColumnInstance, Row, Column} from 'react-table'
import {useQueryResponse, useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {KTCardBody} from '../../../../../_metronic/helpers'
import { UsersListLoading } from '../../../../components/Table/components/loading/UsersListLoading'
import { CustomRow } from '../../../../components/Table/table/columns/CustomRow'
import { BurningItem } from '../core/_models'
import { CustomHeaderColumn } from '../../../../components/Table/table/columns/CustomHeaderColumn'
import { UsersListPagination } from '../../../../components/Table/components/pagination/UsersListPagination'
import { useListView } from '../core/ListViewProvider'
import { BurninngItemEditModal } from '../burning-item-edit-modal/BurninngItemEditModal'

export const BurningItemesTable = ({columns}: {columns: ReadonlyArray<Column<BurningItem>>}) => {
  const users = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => users, [users])
  const {total, errorMessage} = useQueryResponse()
  const {itemIdForUpdate} = useListView()

  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <>
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<BurningItem>) => (
                //@ts-ignore
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<BurningItem>, i) => {
                prepareRow(row)
                //@ts-ignore
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {errorMessage ? <span style={{color: '#f44336'}}>{errorMessage}</span> : 'No matching records found'}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <UsersListPagination isLoading={isLoading} pathname="/burning-items" total={total}/>
      {isLoading && <UsersListLoading />}
    </KTCardBody>
    {itemIdForUpdate !== undefined && <BurninngItemEditModal />}
    </>
  )
}
